import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../home/components/HeroSection';
import TrustBar from '../home/components/TrustBar';
import CategoryGrid from '../home/components/CategoryGrid';
import AIBuyingGuide from '../home/components/AIBuyingGuide';
import FeaturedProducts from '../home/components/FeaturedProducts';
import WhyChooseUs from '../home/components/WhyChooseUs';
import ShippingBenefits from '../home/components/ShippingBenefits';
import Testimonials from '../home/components/Testimonials';
import FAQSection from '../home/components/FAQSection';
import FinalCTA from '../home/components/FinalCTA';

const aboutFAQs = [
  {
    q: 'How long has Blinds USA Inc been in business?',
    a: 'Blinds USA Inc has been selling blind replacement parts and window hardware since 1997 — over 25 years of dedicated specialty parts supply. We started as a small operation focused on hard-to-find vertical blind components and have grown into a full-catalog supplier serving homeowners, property managers, and trade professionals nationwide.',
  },
  {
    q: 'Do you only sell online or do you have a showroom?',
    a: 'We operate primarily as an online parts store with nationwide shipping. Our catalog of 1,000+ SKUs is available on our website 24/7. You can also place orders by phone during business hours. Our focus is fast, accurate fulfillment rather than a retail showroom — which keeps our prices low and shipping speed high.',
  },
  {
    q: 'Who typically shops at Blinds USA Inc?',
    a: 'Our customers range from homeowners fixing a single broken slat to property managers ordering parts in bulk for entire apartment buildings. We also serve professional blind installers, facility maintenance teams, and general contractors who need reliable parts quickly. Our pricing and shipping options work well for both single items and large bulk orders.',
  },
  {
    q: 'What makes Blinds USA different from big-box stores?',
    a: 'Big-box stores carry a limited selection of the most common blind parts and rarely stock hard-to-find or discontinued components. Blinds USA specializes in depth of catalog — we carry over 1,000 SKUs including rare parts big-box stores never stock. Our team also knows blind hardware deeply and can help identify the right part even for older or discontinued systems.',
  },
  {
    q: 'Do you offer bulk pricing for property managers?',
    a: 'Yes — we offer discounted combined shipping and can work with property managers, maintenance teams, and trade customers on bulk orders. Call our parts team to discuss quantities and pricing. We regularly supply parts for multi-unit residential properties, commercial buildings, and hotel renovations across the country.',
  },
  {
    q: 'How do I contact Blinds USA customer support?',
    a: 'Our parts specialists are available by phone at 1-800-555-1234, Monday through Friday from 8 AM to 6 PM Eastern. You can also reach us by email at parts@blindsusainc.com. If you\'re not sure which part you need, call us — our team can help identify the correct replacement component from a description of your blind and the problem you\'re experiencing.',
  },
];

export default function AboutPage() {
  return (
    <main className="min-h-screen font-sans">
      <Navbar />
      <HeroSection
        content={{
          tag: 'Blind Parts & Window Hardware Specialists Since 1997',
          titleLine1: 'About',
          titleHighlight: 'Blinds USA Inc',
          titleLine2: 'Your Trusted Parts Supplier',
          subtitle:
            'Since 1997, we\'ve been the go-to source for blind replacement parts and window hardware. Over 1,000 parts in stock, nationwide fast shipping, and real parts specialists ready to help.',
          ctaPrimary: 'Shop All Parts',
          ctaPrimaryHref: '/category/vertical-blind-parts',
          ctaSecondary: 'Browse Categories',
          ctaSecondaryHref: '#categories',
          bgImage:
            'https://public.readdy.ai/ai/img_res/da1737f4021807e28ef999a6f704b270.jpg',
          stats: [
            { value: 'Est. 1997', label: 'Year Founded' },
            { value: '1,000+', label: 'Parts In Stock' },
            { value: '50K+', label: 'Orders Shipped' },
            { value: '4.9★', label: 'Customer Rating' },
          ],
        }}
      />
      <TrustBar />
      <CategoryGrid
        title="Shop Our Full Parts Catalog"
        subtitle="25+ years of sourcing and stocking the parts others can't find"
      />
      <AIBuyingGuide
        content={{
          mainQ: 'Who Is Blinds USA Inc and What Do We Sell?',
          mainA: 'Blinds USA Inc is a specialty online retailer of blind replacement parts and window hardware, founded in 1997. We stock over 1,000 SKUs covering vertical blind parts, horizontal blind components, mini blind hardware, valance clips, mounting brackets, chains, cords, and drapery hardware. We ship to all 50 states with fast processing and discounted combined shipping on multi-item orders.',
        }}
      />
      <FeaturedProducts
        title="Our Most Popular Parts"
        subtitle="Top-selling items trusted by homeowners and property managers nationwide."
      />
      <WhyChooseUs />
      <ShippingBenefits />
      <Testimonials />
      <FAQSection
        content={{
          title: 'About Blinds USA Inc — Common Questions',
          items: aboutFAQs,
        }}
      />
      <FinalCTA />
      <Footer />
    </main>
  );
}
